import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";

import TestimonialImage from "../../../../../assets/images/png/courses/testimonies/emmanuel.jpeg";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/faith.webp";
import SerahmercyImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/SERAHMERCY SUIT - Product Management & Design and Software Development Support Person.png";

import Testimony1 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/abayomi.webp";
import Testimony3 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/evelyn.webp";
import Testimony4 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/tolulope.webp";
import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/yusuf.webp";

import OlorundareImage from "../../../../../assets/images/png/courses/testimonies/olorundare.png";
import TestimonyOladeleImage from "../../../../../assets/images/png/courses/testimonies/testimony.png";
import AdugboImage from "../../../../../assets/images/png/courses/testimonies/adugbo.png";
import OnyeaniImage from "../../../../../assets/images/png/courses/testimonies/onyeani.png";
import AbiodunImage from "../../../../../assets/images/png/courses/testimonies/abiodun.png";
import OlubukolaImage from "../../../../../assets/images/png/courses/testimonies/olubukola.png";
import ChukwundaImage from "../../../../../assets/images/png/courses/testimonies/chukwunda.png";
import AbdulsalamImage from "../../../../../assets/images/png/courses/testimonies/abdulsalam.png";
import OpeyemiImage from "../../../../../assets/images/png/courses/testimonies/opeyemi.png";
import RoselynImage from "../../../../../assets/images/png/courses/testimonies/roselyn.png";
import GbemilekeImage from "../../../../../assets/images/png/courses/testimonies/gbemileke.png";
import AfeezImage from "../../../../../assets/images/png/courses/testimonies/afeez.png";
import AniImage from "../../../../../assets/images/png/courses/testimonies/ani.png";
import OgunlanaImage from "../../../../../assets/images/png/courses/testimonies/ogunlana.png";
import AjayiImage from "../../../../../assets/images/png/courses/testimonies/ajayi.png";
import LateefImage from "../../../../../assets/images/png/courses/testimonies/lateef.png";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/product.webp";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import ProductDesignPreview from "../../../../../assets/images/jpeg/pdPreview.jpg";

export const productDesignAfrica = {
  id: 1,
  tag: "FOR STARTERS",
  title: "Design Bootcamp",
  seoTitle: "UI/UX Design Bootcamp in Nigeria | Utiva",
  description: `
  This design bootcamp program is taught by tech leaders and created as project-based learning to 
  help you develop the skills needed to create user experiences for products or digital properties.
    `,
  metatags: `Learn UI/UX design from scratch with expert mentors. Gain hands-on experience with real-world projects and become job-ready in 12 weeks. Enrol today at Utiva.`,
  keywords: `UI/UX design career, is UX design worth learning, UX design salary Africa, UI/UX bootcamp, learn UX design fast, product design bootcamp Nigeria, product design bootcamp curriculum, UI/UX course outline, what does a design bootcamp teach, best UI/UX bootcamp Nigeria, Utiva design bootcamp review, enroll product design course, product designer daily tasks, product designer responsibilities 2026, UI UX designer day in the life, product design career 2026, how to become a product designer in Nigeria, what is product design, product designer job description, product design course in Nigeria, UI UX design course Africa, learn product design Lagos, Utiva product design, tech skills Nigeria 2026, product designer salary Nigeria, how to get hired as a product designer 2026, product design bootcamp vs self learning, how to learn UI UX design fast, best way to learn product design, online design programme vs self taught, how long does it take to learn product design, product design course online 2026, how to become a UI UX designer fast, product design course Nigeria, UI UX bootcamp Africa 2026, Utiva product design programme, tech career Nigeria 2026, product design scholarship Africa, how to get a tech job in Nigeria, remote design jobs Africa, Figma for beginners, UX portfolio tips, product design timeline, design bootcamp Nigeria, self-taught designer portfolio, UI UX career path, design mentorship Africa, junior product designer, product design salary Nigeria, remote product design jobs, design thinking course, junior product designer portfolio, remote product design jobs Africa, AI in product design, product manager vs product designer, usability testing, design systems, prototyping in Figma, wireframing tools, UX research methods`,
  duration: "3 months",
  downloadBrochureUrl:
    "https://drive.google.com/file/d/1egX1GPZfi90VhCkQIyaUGIWx0hwBZ4nf/view?usp=sharing",

  courseFormUrl: "courses/design-bootcamp/fill-form",

  jobTitle: "Product Designer",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    image: TestimonialImage,
    name: "Emmanuel Umoru",
    role: "Co-founder, HTML Foods",
    testimony: `
    The knowledge I acquired from this program is something I used 
    to build my Food Delivery Business. Learning Design Thinking 
    helped me understand customers' needs. In fact, this skill 
    helped me in my food photography. I became more creative with 
    my pictures. I'm happy to say that I truly enjoyed my learning 
    experience and learnt a lot from it. Interacting with other classmates, 
    sharing ideas and receiving feedback was the most interesting part for me`,
    starRating: "5.0",
  },

  courseOverview: {
    title: `The UI/UX training program is designed to give learners the required skills, 
    knowledge and leveraged needed to becomes designers in the technology industry. `,
    desc: `
    Taught by industry leaders, the course uses a project-based learning model, 
    ensuring professionals gain hands-on experience creating digital products 
    with the user firmly in mind. Your best course for career transformation 
    in design. This full-time UX bootcamp features expert instruction, 
    one-on-one career coaching, and connections to top employers to get you hired.
    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Introduction to Product Design & UI/UX Design",
      unitTag:
        "Critical Thinking & Problem-Solving, Basic UI/UX Principles, Design Thinking Framework",
      unitDescription: `
      This unit lays the foundation for understanding product design, UI/UX design, and the core
      principles behind crafting user-centered experiences. Students will gain insight into the design
      process, essential skills, and industry expectations.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "What is Product Design?",
          featureDescription: `Understanding product design as a problem-solving approach that balances user needs, business goals, and technology.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Differences Between UI & UX Design",
          featureDescription: `UX (User Experience) focuses on functionality and usability, while UI (User Interface) emphasizes visual aesthetics and interactivity.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Key Skills for a Product Designer",
          featureDescription: `A blend of technical, analytical, and soft skills needed to succeed in product design.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Overview of the Design Thinking Process",
          featureDescription: `A structured approach to problem-solving that includes empathizing, defining, ideating, prototyping, and testing.`,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Deep Dive into Design Thinking & User Research Synthesis",
      unitTag:
        "User Research & Analysis, Data Visualization & Synthesis, Problem Definition & Ideation",
      unitDescription: `
      Learn how to gather and analyze user research data and translate insights into actionable design decisions.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Understanding the Five Stages of Design Thinking",
          featureDescription: `A deep dive into empathy, problem definition, ideation, prototyping, and testing.
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Conducting User Research & Gathering Insights",
          featureDescription: `Methods like interviews, surveys, and usability testing to collect valuable user data.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Visualizing Research Data",
          featureDescription: (
            <ul className="list-disc list-outside pl-2 ">
              <li className="leading-6">
                <strong>User Personas –</strong> Creating profiles that
                represent target users.
              </li>
              <li className="leading-6">
                <strong>User Journey Maps –</strong> Mapping out how users
                interact with a product.
              </li>
              <li className="leading-6">
                <strong>User Flow Diagrams –</strong> Understanding user
                navigation through the product.
              </li>
            </ul>
          ),
        },
        {
          featureIcon: Icon2,
          featureTitle: "Synthesizing Research Data for Decision-Making",
          featureDescription: `Turning research findings into actionable design strategies.
          `,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Sketching & Wireframing",
      unitTag:
        "Sketching & Rapid Ideation, Low-Fidelity Wireframing, Tool Proficiency (Whimsical, FigJam, Figma)",
      unitDescription: `
      Students will explore the process of translating ideas into low-fidelity wireframes and learn how
      to use key design tools for sketching and prototyping.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Introduction to Sketching and Wireframing",
          featureDescription: `The importance of low-fidelity sketches in early design stages.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Exploring Tools for Sketching & Wireframing",
          featureDescription: (
            <ul className="list-disc list-outside pl-2 ">
              <li className="leading-6">
                <strong>Whimsical –</strong> Quick diagramming and wireframing.
              </li>
              <li className="leading-6">
                <strong>FigJam –</strong> Brainstorming, collaboration, and
                early design explorations.
              </li>
              <li className="leading-6">
                <strong>Figma –</strong> High-fidelity wireframing and UI
                design.
              </li>
            </ul>
          ),
        },
        {
          featureIcon: Icon3,
          featureTitle: "Best Practices for Wireframing",
          featureDescription: `Guidelines for creating effective and user-friendly wireframes.`,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Designing with Figma",
      unitTag:
        "UI Design Principles, Advanced Figma Techniques (Auto Layout, Components), Responsive Design",
      unitDescription: `
      Gain hands-on deep dive into Figma, covering advanced UI design concepts, responsive design
      techniques, and building scalable design systems.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Understanding Figma’s Interface & Features",
          featureDescription: `Navigating the workspace, working with layers, frames, and design tools.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Working with Auto Layout for Scalable UI",
          featureDescription: `Creating flexible, adaptable UI components that adjust dynamically.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Creating & Using Components for Design Systems",
          featureDescription: `Building reusable elements to maintain consistency across designs.`,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Designing for Different Screen Sizes (Responsive Design)",
          featureDescription: `Ensuring seamless user experiences across various devices.`,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle: "Developing Design Solutions & Working in Teams",
      unitTag:
        "Collaboration & Communication, Agile & Iterative Design Processes, Ideation & Concept Development",
      unitDescription: `
      This unit focuses on applying design principles to create user-centered solutions while learning
      how to collaborate in a team environment using agile methodologies.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Concept Development & Design Ideation",
          featureDescription: `Generating and refining creative ideas based on user needs.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Iterating & Refining Design Solutions",
          featureDescription: `Using feedback loops to improve and polish designs.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Working in Teams as a Product Designer",
          featureDescription: `Strategies for effective teamwork, communication, and collaboration.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Introduction to Agile Methodologies",
          featureDescription: `Understanding how agile workflows apply to design, including sprints, stand-ups, and iterative development.`,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "Portfolio Development & Group Design Project (DesignCon)",
      unitTag:
        "Portfolio Development & Case Study Writing, Presentation & Storytelling, Team Collaboration & Project Execution",
      unitDescription: `
     This unit prepares you for industry readiness by guiding through portfolio building and a real-world group project.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Portfolio Building",
          featureDescription: (
            <ul className="list-disc list-outside pl-2 ">
              <li className="leading-6">
                <strong>What Makes a Strong Portfolio? –</strong> Essential
                elements of a standout design portfolio.
              </li>
              <li className="leading-6">
                <strong>Structuring Case Studies & Showcasing Work –</strong>{" "}
                Presenting projects effectively.
              </li>
              <li className="leading-6">
                <strong>Common Mistakes to Avoid –</strong> Pitfalls that weaken
                portfolio credibility.
              </li>
            </ul>
          ),
        },
        {
          featureIcon: Icon2,
          featureTitle: "Group Design Project (DesignCon)",
          featureDescription: (
            <ul className="list-disc list-outside pl-2 ">
              <li className="leading-6">
                <strong>Design Brief Walkthrough –</strong> Understanding and
                breaking down project requirements.
              </li>
              <li className="leading-6">
                <strong>Collaborative Project Execution –</strong> Working as a
                team to develop solutions.
              </li>
              <li className="leading-6">
                <strong>Presenting Final Designs –</strong> Effectively
                communicating design decisions.
              </li>
            </ul>
          ),
        },
      ],
    },
    {
      unitId: 7,
      unitTitle: "AI-Enhanced Design",
      unitTag:
        "AI-Assisted Ideation & Prototyping, AI for Research & Data Analysis, Automating Repetitive Design Tasks",
      unitDescription: `
      This section introduces how AI can accelerate design workflows and decision-making.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Speeding Up Design Processes Using FigJam AI",
          featureDescription: `Using AI-powered tools for brainstorming, ideation, and prototyping.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "How to Utilize AI as a Designer",
          featureDescription: `Leveraging AI tools like ChatGPT, MidJourney, and Runway AI for ideation and automation.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "AI-Driven User Research",
          featureDescription: `Analyzing user behavior patterns using AI-powered analytics tools. `,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Okolo Faith Ogochukwu",
      coachRole: "Senior Product Designer",
    },
    {
      coachId: 2,
      coachImage: SerahmercyImage,
      coachName: "Serahmercy Olaoye",
      coachRole: "Product Management & Design Support",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Learning Model",
      modelDescription:
        "A 3 months experiential learning and hands-on training session.",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Training Methodology",
      modelDescription: "Learn through real-life problems",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Business Case-Focused",
      modelDescription:
        "Work on real-life projects by applying what you learn to solve related business problems.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Access Contents & Materials",
      modelDescription: "50% on your own + 50% in live classes",
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "https://www.linkedin.com/in/olowu-abayomi-896969101/",
      image: Testimony1,
      firstname: "Abayomi",
      lastname: "Olowu",
      company: "Product Designer, CashToken Africa",
      testimony: `
      I have always wanted to make a career transition to 
      product design, UTIVA made it happen for me. With the hands-on learning 
      style, real-life business cases and unending mentorship from my trainers 
      and coaches, I was very impressed with the project my team and I did 
      in the class, which was hat i added to my portfolio, and with it, 
      I was able to land a role as a UI/UX designer in a well funded Nigerian startup. 
      `,
    },
    {
      id: 4,
      linkedIn: "https://www.linkedin.com/in/adetifa-toluwalope-03a30177/",
      image: Testimony4,
      firstname: "Toluwalope",
      lastname: "Adetife",
      company: "Product Intern, Celery",
      testimony: `
      Utiva gave me the opportunity to know more. 
      I had the opportunity to do things I thought I couldn’t do 
      with the help of wonderful Tutors and Cohort Captain.
      The training significantly helped me with my career transition
      `,
    },
    {
      id: 2,
      linkedIn: "",
      image: Testimony2,
      firstname: "Yusuf",
      lastname: "Abdusalam",
      company: "Product Designer/Research , Dangote Group",
      testimony: `
      I never thought I could turn out this good! I am very 
      grateful to Utiva Design School for this Opportunity. This is a 
      starting milestone to changing my career life for the better. 
      I am ready to pursue more and more with the support 
      I get from my trainers and other students, making the experience a dream come true
      `,
    },
    {
      id: 3,
      linkedIn: "https://www.linkedin.com/in/evelyn-ebo/",
      image: Testimony3,
      firstname: "Evelyn",
      lastname: "Ebo",
      company: "Product Operations Specialist, Advans Nigeria",
      testimony: `
      Utiva has impacted my career progression in a positive
      way as the changes in the last couple of months have been rapid.
      I've had to change roles from a business-oriented role to a
       digital-oriented role. I've had opportunities to implement my
       learnings in real-life scenarios, had a role change to a Digital role, scholarships,
      and also volunteering roles. I feel fulfilled implementing my passion
      `,
    },
    {
      id: 5,
      linkedIn: "",
      image: OlorundareImage,
      firstname: "Olorundare",
      lastname: "Femi",
      company: "",
      testimony: `
      I'm having a good time and exploring how product design works and what it means. The trainer Uche made it easy.
      `,
    },
    {
      id: 6,
      linkedIn: "",
      image: TestimonyOladeleImage,
      firstname: "Testimony",
      lastname: "Oladele",
      company: "",
      testimony: `
      My training has been amazing so far. My trainer, Faith Okolo (Product Design Coach) has been outstanding too.
      She explains each lesson clearly and delivers in an engaging way.
      `,
    },
    {
      id: 7,
      linkedIn: "",
      image: AdugboImage,
      firstname: "Adugbo",
      lastname: "Ochuko",
      company: "",
      testimony: `
      It is getting a lot more interesting and difficult with the practicals in product design. But with dedication
      and determination, also with the help of my coach Faith Okolo, it's been super easy to navigate through. I am
      looking forward to finishing strong with her.
      `,
    },
    {
      id: 8,
      linkedIn: "",
      image: OnyeaniImage,
      firstname: "Onyeani",
      lastname: "Isaac",
      company: "",
      testimony: `
      I love Faith Okolo on Product Design, her teaching was engaging and very easy to understand. I enjoy the
      session. It was very interesting, I love the communication and I love how she explains it bit by bit.
      `,
    },
    {
      id: 9,
      linkedIn: "",
      image: AbiodunImage,
      firstname: "Abiodun",
      lastname: "Owoddunni",
      company: "",
      testimony: `
      It's been a wonderful experience so far. Faith Okolo is a master instructor, fully knowledgeable about product
      design. She has been able to break down the technical aspects of the course, and she is always on hand to
      respond to enquiries outside course hours.
      `,
    },
    {
      id: 10,
      linkedIn: "",
      image: OlubukolaImage,
      firstname: "Olubukola",
      lastname: "Oyalowo",
      company: "",
      testimony: `
      I took the Product Design course at Utiva Academy and had a great experience. The instructor was extremely
      helpful and made complex concepts easy to understand. The course content was well-structured and practical,
      she made learning engaging and relevant. I definitely recommend it to anyone looking to get started in product
      design or improve their skills.
      `,
    },
    {
      id: 11,
      linkedIn: "",
      image: ChukwundaImage,
      firstname: "Chukwunda",
      lastname: "Gift",
      company: "",
      testimony: `
      I had a very wonderful learning experience during my Product Design lectures, and my design coach, Miss Faith
      Okolo is best at what she does. The classes were intuitive as well as engaging, and our tutor made very sure
      that everyone was carried along; it doesn't matter how much she has to recap and rephrase. Even when I couldn't
      practise during classes, due to an unavailable laptop, I could still grasp what was being taught, and try them
      on my own later on. The recorded classes are also an added advantage. I so much appreciate this great
      privilege of learning from the best.
      `,
    },
    {
      id: 12,
      linkedIn: "",
      image: "",
      firstname: "Mercy",
      lastname: "Nwose",
      company: "",
      testimony: `
      I had a very fantastic experience during the course of my training on product design, it was an awesome
      journey. A very big thanks to Utiva and to our amiable tutor in person of Miss Faith Okolo for this great
      opportunity given.
      `,
    },
    {
      id: 13,
      linkedIn: "",
      image: AbdulsalamImage,
      firstname: "Abdulsalam",
      lastname: "Yusuf",
      company: "",
      testimony: `
      Utiva School is a life experience for me because it has shown me the world of design. Going through a
      three-week intensive training with highly qualified instructors and learning with a diversified folk from all
      walks of life has not only changed my perspective about designing a product but also prepared me for the
      future to come.
      `,
    },
    {
      id: 14,
      linkedIn: "",
      image: OpeyemiImage,
      firstname: "Opeyemi",
      lastname: "Temenu",
      company: "",
      testimony: `
      My experience in Utiva Design School was amazing. Not only are the key things to product design taught, it
      also exposes you to a community of like-minded people who are interested in the taught course. These people
      are from different spheres which makes them diverse and makes the community interesting. The tutors are also
      available outside the class for any questions one has.
      `,
    },
    {
      id: 15,
      linkedIn: "",
      image: RoselynImage,
      firstname: "Roselyn",
      lastname: "Edema",
      company: "",
      testimony: `
      I am currently enrolled in June's Product Design cohort. My favorite thing is how interactive the virtual
      classes are. The follow up and mentorship is also top notch. It is well worth every penny.
      `,
    },
    {
      id: 16,
      linkedIn: "",
      image: GbemilekeImage,
      firstname: "Gbemileke",
      lastname: "Anthony",
      company: "",
      testimony: `
      I signed up for a 3-week long Design training with Utiva and I thoroughly enjoyed it. I was introduced to the
      fundamental concepts in the Product Design process and design tools like Figma. Design School was the much
      needed launchpad for my foray into UI/UX.
      `,
    },
    {
      id: 17,
      linkedIn: "",
      image: AfeezImage,
      firstname: "Afeez",
      lastname: "Saka",
      company: "",
      testimony: `
      Utiva made me accomplish one of my goals for 2020. I was able to enroll for the Product Design Class, and I
      became blessed with the content, the delivery, and the amazing facilitators. Sure, UTIVA is a pacesetter among
      the Tech Industry. Empowering and preparing youths for the Future of Work.
      `,
    },
    {
      id: 18,
      linkedIn: "",
      image: AniImage,
      firstname: "Ani",
      lastname: "John King",
      company: "",
      testimony: `
      Wow! Amazing! I've actually been trying to learn product designing on my own, but it wasn't really working out
      fine. I'm glad I'll be attending the class with Utiva, and I can't wait!
      `,
    },
    {
      id: 19,
      linkedIn: "",
      image: OgunlanaImage,
      firstname: "Ogunlana",
      lastname: "Segun",
      company: "",
      testimony: `
      Utiva programs are highly responsive to emerging technologies' needs in Nigeria and Africa as a whole. I
      enrolled for the design class in June and I got an appreciable amount of experience to kickstart a career
      journey in UI/UX & Product Design.
      `,
    },
    {
      id: 20,
      linkedIn: "",
      image: AjayiImage,
      firstname: "Ajayi",
      lastname: "Praise",
      company: "",
      testimony: `
      Great class on UI/UX product design. Great teacher, explained everything in very simple terms. Enjoyed every
      bit of the master class. Thank you Utiva.
      `,
    },
    {
      id: 21,
      linkedIn: "",
      image: LateefImage,
      firstname: "Lateef",
      lastname: "Yusuf",
      company: "",
      testimony: `
      Great introductory class to Product Design. Facilitator was clearly knowledgeable and experienced. I'm glad I
      attended.
      `,
    },
    {
      id: 22,
      linkedIn: "",
      image: "",
      firstname: "Obansola",
      lastname: "Sadiat",
      company: "",
      testimony: `
      The experience has been truly amazing! I really appreciate our amiable tutor Miss Faith Okolo for the great
      work, she has been truly helpful in guiding and directing me in my product design journey. Thanks so much for
      being a great tutor and huge thanks to Utiva.
      `,
    },
    {
      id: 23,
      linkedIn: "",
      image: "",
      firstname: "Semiat",
      lastname: "Lawal",
      company: "",
      testimony: `
      Learning Product Design with Utiva has been an amazing experience! The classes were clear, practical, and very
      engaging. Miss Faith Okolo was an incredible tutor, always patient, encouraging, and deeply knowledgeable. I've
      grown so much in this short time and feel more confident in my design skills. I'm really proud of how far I've
      come, and I'm grateful to have learned alongside such a great community.
      `,
    },
    {
      id: 24,
      linkedIn: "",
      image: "",
      firstname: "Oniyide",
      lastname: "Pelumi",
      company: "",
      testimony: `
      I enrolled for the Product Design class. It was a wonderful experience. I didn't know anything about Figma or
      UI/UX, but with this course, I was able to understand a lot and now I can design apps to a great extent. I want
      to say thank you to Utiva, I was able to learn a lot through the platform and also thank you to my tutor Miss
      Faith Okolo, she taught us very well. This course has helped me kickstart my career into tech and I hope to
      explore more fields in Product Design.
      `,
    },
    {
      id: 25,
      linkedIn: "",
      image: "",
      firstname: "Lahazee",
      lastname: "Incorporated",
      company: "",
      testimony: `
      It is a great learning process on Utiva Product Design. It is an awesome experience being tutored by Faith
      Okolo.
      `,
    },
    {
      id: 26,
      linkedIn: "",
      image: "",
      firstname: "Oluwaseyi",
      lastname: "A",
      company: "",
      testimony: `
      The UI/UX Design (Product Design) training at Utiva is an outstanding program for anyone looking to break into
      or advance in the field of product design. The curriculum is well-structured, covering everything from
      foundational design principles to advanced UX research, prototyping, and usability testing. What sets Utiva
      apart is its hands-on, project-based approach, you don't just learn theory; you work on real-world projects
      that build a strong portfolio. The instructors are industry professionals who provide practical insights and
      mentorship, ensuring students grasp both the creative and technical aspects of design. Additionally, the
      collaborative learning environment and access to a supportive community of designers make the experience even
      more enriching. By the end of the program, I felt confident in my ability to create user-centered designs and
      leverage tools like Figma, FigJam, Miro, Flowmap, and more. If you're serious about a career in UI/UX or any
      other tech skillsets, Utiva's training is a fantastic investment!
      `,
    },
    {
      id: 27,
      linkedIn: "",
      image: "",
      firstname: "MisterChrome",
      lastname: "Henry",
      company: "",
      testimony: `
      This class was incredibly well-structured and engaging. The instructor explained concepts clearly and provided
      real-world examples that made the lessons easy to understand and apply. I especially appreciated the hands-on
      projects and the supportive learning environment. I gained valuable skills and feel more confident moving
      forward. Highly recommended for anyone looking to deepen their knowledge!
      `,
    },
    {
      id: 28,
      linkedIn: "",
      image: "",
      firstname: "Eze",
      lastname: "Godwinson",
      company: "",
      testimony: `
      I really enjoyed my learning experience under Utiva. Miss Faith Nwolo did a very good job and this made me love
      product design more.
      `,
    },
    {
      id: 29,
      linkedIn: "",
      image: "",
      firstname: "Muritala",
      lastname: "Risikot Omotoke",
      company: "",
      testimony: `
      My experience so far at Utiva, taking a course on UI/UX with my trainer, Faith Okolo has been a wonderful
      experience from getting to understand what product design is and hands-on practicals that help grasp the vivid
      knowledge of product design.
      `,
    },
    {
      id: 30,
      linkedIn: "",
      image: "",
      firstname: "Ifeoluwa",
      lastname: "Odunola",
      company: "",
      testimony: `
      My experience so far has been insightful, even though I have only attended one live session of the product
      design class. My trainer is patient, calm, and well-coordinated, which makes the learning process enjoyable. I
      also appreciate the structured approach that requires completing one course before moving on to the next, it
      fosters discipline and encourages seriousness. Above all, my experience with the dashboard has been smooth and
      user-friendly.
      `,
    },
  ],

  portofolio: {
    title: "Build and Showcase Your Product Design(UI/UX) Portfolio",
    description: `
    To earn your Product Design certification, showcase everything you've 
    learned in a pitch presentation where experts evaluate your 
    new product Design skillset.
      `,

    name: "Olatunji Abayomi",
    // image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Product Design Certification",
    description: `
    Upon completing Utiva's Design Bootcamp Course, you'll receive an 
    industry-recognized, professional Product Design certification to 
    share with your network and showcase all that you've learned. 
    Utiva certificates are formatted for sharing on LinkedIn.
      `,
  },

  // videoTestimonial: "https://youtube.com/embed/BmN-diHqerY",
  // videoTestimonial: "https://www.youtube.com/embed/W2uIac2qVrU",
  videoTestimonial: "https://www.youtube.com/embed/EPfIqFcyBco",
  videoPreviewImage: ProductDesignPreview,

  otherCourses: [
    {
      id: 1,
      courseTitle: "Product Accelerator",
      courseDescription: `This training is designed by top professionals to help you fast-track 
      your career in Product Management. Designed for those that already 
      have their foot in the industry and want to fast-track their career.`,
      courseUrl: "/courses/product-management-and-design-bootcamp",
    },
  ],
};
